export const englanguage="en";
export const arblanguage="arb"